import type {
  IPinpointPartnerMessage,
  ISingularEmailBaseCampaign,
  SingularEmailBaseCampaign,
} from '@feathr/blackbox';
import { PinpointPartnerMessage } from '@feathr/blackbox';

/**
 * A Pinpoint or Mailrail partner message. This single structural type lets callers accept
 * either class without a `PinpointPartnerMessage | MailrailPartnerMessage` union, whose
 * differing `get` overloads don't unify.
 */
export type TPartnerMessage = SingularEmailBaseCampaign<
  ISingularEmailBaseCampaign & Pick<IPinpointPartnerMessage, 'invites_campaign' | 'participation'>
>;

/** A partner message's send time: Mailrail keeps it in date_start, Pinpoint in date_send_start. */
export function getPartnerMessageSendTime(message: TPartnerMessage): string {
  if (message instanceof PinpointPartnerMessage) {
    return message.get('date_send_start');
  }
  return message.get('date_start');
}
